import styled from 'styled-components'
import { Modal } from '@sketch/components'
import { ReactComponent as ExclamationMark } from '@sketch/icons/exclamation-mark-triangle-64'

export const ModalStyled = styled(Modal)`
  max-width: 640px;
`

export const ErrorIcon = styled(ExclamationMark)`
  flex: none;
  width: 64px;
  height: 64px;
  opacity: 0.55;
`
